import { createContext, useContext } from 'react'

import { InferenceMessageActions, InferenceMessageState } from './messageStore'

export type InferenceMessageContextValue = InferenceMessageState & InferenceMessageActions

export const InferenceMessageContext = createContext<InferenceMessageContextValue | null>(null)

export function useInferenceMessageContext() {
  const context = useContext(InferenceMessageContext)
  if (!context) {
    throw new Error('useInferenceMessageContext must be used within InferenceProvider')
  }
  return context
}
